import React from 'react';

export default () => (
    <svg width="20" height="20">
        <g fill="none" fill-rule="evenodd" stroke="#14B820" stroke-width="1.4">
            <path stroke-linecap="round" d="M5.841 9.528l3.08 2.989 5.189-5.189" />
            <circle cx="9.976" cy="9.923" r="9" />
        </g>
    </svg>
);
